import {
    BlockStack,
    Button,
    Card,
    InlineGrid,
    InlineStack,
    Layout,
    Page,
    Text,
} from "@shopify/polaris";
import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate } from "react-router-dom";

type NavigationCard = {
    title: string;
    summary: string;
    path: string;
    cta: string;
};

const cards: NavigationCard[] = [
    {
        title: "Products",
        summary: "Browse catalog items and review fitment status.",
        path: "/products",
        cta: "Open products",
    },
    {
        title: "Vehicles",
        summary: "Manage vehicle definitions and mappings.",
        path: "/vehicles",
        cta: "Open vehicles",
    },
    {
        title: "Imports",
        summary: "Upload files and review import history.",
        path: "/imports",
        cta: "Open imports",
    },
    {
        title: "Settings",
        summary: "Configure app behavior and defaults.",
        path: "/settings",
        cta: "Open settings",
    },
];

const Dashboard = () => {
    const navigate = useNavigate();

    return (
        <Page title="Part Finder">
            <Layout>
                <Layout.Section>
                    <Card>
                        <BlockStack gap="400">
                            <InlineStack align="space-between" blockAlign="center">
                                <Text as="h2" variant="headingMd">
                                    Alpha release
                                </Text>
                                <Button variant="primary" onClick={() => navigate("/settings")}>
                                    Review setup
                                </Button>
                            </InlineStack>

                            <Text as="p" tone="subdued">
                                Questions? support@govedia.com
                            </Text>

                            <InlineGrid columns={{ xs: 1, md: 2 }} gap="400">
                                {cards.map((c) => (
                                    <Card key={c.path}>
                                        <BlockStack gap="200">
                                            <Text as="h3" variant="headingMd">
                                                {c.title}
                                            </Text>
                                            <Text as="p" tone="subdued">
                                                {c.summary}
                                            </Text>
                                            <Button onClick={() => navigate(c.path)}>{c.cta}</Button>
                                        </BlockStack>
                                    </Card>
                                ))}
                            </InlineGrid>
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
};

export default observer(Dashboard);
